import { AtlasRatingsV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasRatingsV2PageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasRatingsV2PageLayout() {
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'AtlasRatingsV2PageLayout',
        CustomComponent: AtlasRatingsV2PageLayout,
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
